import type { SkillSummary } from '@tabbio/types';
import { formatSkillCommand } from '@/components/skills/skill-name';

// Feeds the single horizontally-scrollable row in ChatStarterSkills.tsx/.web.tsx.
export const CHAT_STARTER_SKILLS_LIMIT = 8;

export type ChatStarterSkillAction = { type: 'run'; command: string };

export function getChatStarterSkillAction(
  skill: Pick<SkillSummary, 'installed' | 'ownerUserId' | 'skillId'>,
): ChatStarterSkillAction {
  return {
    type: 'run',
    command: formatSkillCommand(skill.skillId),
  };
}
